'use client';
import { canonicalizeLegacyPermalinkUrl } from '#pplx/frontend/apps/ask/permalink-slug/canonicalizeLegacyPermalink.js';
import { relativePath } from '#pplx/frontend/router/UrlUtils.js';
import { usePathname } from '#pplx/frontend/router/usePathname.js';
import { useMemo } from 'react';
/** Keep legacy permalink titles out of the visible URL across initial load and SPA navigation. */
export function useCanonicalizeLegacyPermalink(base = '') {
    const pathname = usePathname();
    // This must run during render, before child providers such as Instrumentation.
    return useMemo(() => {
        canonicalizeLegacyPermalinkUrl({
            pathname: window.location.pathname,
            search: window.location.search,
            hash: window.location.hash,
        }, window.history);
        const canonicalPathname = relativePath(window.location.pathname, base) || '/';
        return canonicalPathname === pathname ? pathname : canonicalPathname;
    }, [base, pathname]);
}
//# sourceMappingURL=useCanonicalizeLegacyPermalink.js.map